import React from 'react'
import moment from 'moment'
import { closingTime } from '../clubCreationForm'

const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
const clock = /^(?:[01]\d|2[0-3]):[0-5]\d$/
const display = value => {
  if (value?.enabled === false) return 'Closed'
  if (value?.enabled !== true) return 'Not provided'
  if (value.startTime !== undefined || value.endTime !== undefined) {
    const end = closingTime(value.endTime)
    return clock.test(value.startTime) && (clock.test(end) || end === '24:00') && end > value.startTime
      ? value.startTime + ' – ' + end : 'Not provided'
  }
  const start = value.startDate && moment(value.startDate), end = value.endDate && moment(value.endDate)
  return start?.isValid() && end?.isValid() ? start.format('HH:mm') + ' – ' + end.format('HH:mm') : 'Not provided'
}

export default function ClubOpeningHours({ openHours }) {
  if (!openHours || !Object.keys(openHours).length) return <div className="club-profile-empty">Opening hours not provided.</div>
  return <div className="club-profile-hours">{days.map(day => <div className="club-profile-hours-row" key={day}>
    <span>{day}</span><strong>{display(openHours[day.slice(0, 3)] ?? openHours[day.toLowerCase()])}</strong>
  </div>)}</div>
}
